import type { Entitlements, ModuleFeature, Permission } from "@cafe/shared";
import { useQuery } from "@tanstack/react-query";
import { authApi } from "@/features/auth/api";
import { useAuth } from "@/features/auth/store";
import { api } from "@/shared/api/client";

export type EffectivePermissions = { company: Permission[]; branches: Record<string, Permission[]>; branchIds: string[] | null };

export const sessionKeys = { me: ["me"] as const, permissions: ["me", "permissions"] as const, entitlements: ["me", "entitlements"] as const };

export const useMe = () => useQuery({ queryKey: sessionKeys.me, queryFn: authApi.me, staleTime: 5 * 60_000 });

export const usePermissions = () =>
  useQuery({ queryKey: sessionKeys.permissions, queryFn: () => api<EffectivePermissions>("GET", "/me/permissions", { branch: false }), staleTime: 60_000 });

export const useEntitlements = () =>
  useQuery({ queryKey: sessionKeys.entitlements, queryFn: () => api<Entitlements>("GET", "/me/entitlements", { branch: false }), staleTime: 60_000 });

/** Право в текущем филиале (или на уровне компании). Пока права грузятся — false (кнопки скрыты). */
export function useCan() {
  const { data } = usePermissions();
  const branchId = useAuth((s) => s.branchId);
  return (p: Permission) => !!data && (data.company.includes(p) || (!!branchId && (data.branches[branchId]?.includes(p) ?? false)));
}

export function useFeature() {
  const { data } = useEntitlements();
  return (f: ModuleFeature | undefined) => !f || !!data?.features.includes(f);
}
